var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLink = function SvgIconLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m13.132 6.45.88-.89a3.134 3.134 0 0 1 4.426 4.428L15.616 12.8l-.003.002a3.115 3.115 0 0 1-4.414 0 1 1 0 0 0-1.417 1.412 5.116 5.116 0 0 0 7.247.001l2.839-2.83.033-.034a5.134 5.134 0 0 0-7.29-7.218l-.9.91a1 1 0 0 0 1.421 1.406M9.4 10.518a3.12 3.12 0 0 1 3.402.678 1 1 0 0 0 1.417-1.411 5.116 5.116 0 0 0-7.247-.001l-2.84 2.83-.033.034a5.134 5.134 0 0 0 7.29 7.218l.9-.91a1 1 0 1 0-1.42-1.406l-.881.89a3.134 3.134 0 0 1-4.425-4.428L8.384 11.2l.003-.002c.29-.291.633-.522 1.012-.679",
    clipRule: "evenodd"
  })));
};
export default SvgIconLink;